import EmailCallout, { EmailTypes } from './email-callout'

export { EmailCallout as default, EmailTypes }
